import React from 'react';
import VerificationInput from 'react-verification-input';
import './CodeInputField.scss'; // Import as global CSS instead of CSS modules

// BCC-20: autoComplete defaults to undefined (unchanged, existing behavior
// for callers like MFAuthentication's OTP entry) - pass "off" explicitly
// for credential-style fields (e.g. the kiosk passcode) that must never
// be offered for browser autofill/storage.
const VerificationCodeInput = ({ type, fields, value, onChange, autoComplete }) => {
  return (
    <VerificationInput
      value={value || ''}
      length={fields}
      validChars={type === 'number' ? '0-9' : undefined}
      placeholder=""
      autoFocus
      onChange={onChange}
      classNames={{
        container: 'reactCodeInput',
        character: 'character',
        characterInactive: 'characterInactive',
        characterSelected: 'characterSelected',
        characterFilled: 'characterFilled',
      }}
      inputProps={{
        inputMode: type === 'number' ? 'numeric' : 'text',
        autoComplete,
      }}
    />
  );
};

export default VerificationCodeInput;